// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingUwStartingConfigsPageQueryVariables = Types.Exact<{
  productOfferingId: Types.Scalars['ID']['input'];
}>;


export type ProductOfferingUwStartingConfigsPageQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, name: string, project?:
      | { __typename?: 'StandaloneProject', id: string }
      | { __typename?: 'Region', id: string }
      | { __typename?: 'Market', id: string }
      | { __typename?: 'Community', id: string }
      | { __typename?: 'Subdivision', id: string }
      | { __typename?: 'Lot', id: string }
      | { __typename?: 'Structure', id: string }
      | { __typename?: 'Unit', id: string }
     | null | undefined, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }, productOfferingStartingConfigs: { __typename?: 'ProductOfferingStartingConfigsPage', entities: Array<{ __typename?: 'ProductOfferingStartingConfig', id: string, pinnedOptions: Array<{ __typename?: 'ReadyPlanOption', active: boolean, order: number, id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, active: boolean, forDesignPackages: boolean } }> }> } };

export type ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables = Types.Exact<{
  productOfferingId: Types.Scalars['ID']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type ProductOfferingUwStartingConfigs_CheckoutOptionsQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, options: Array<{ __typename?: 'ReadyPlanOption', active: boolean, order: number, id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, active: boolean, forDesignPackages: boolean } }> } };

export type ProductOfferingUwStartingConfigs_DeleteMutationVariables = Types.Exact<{
  input: Types.DeleteEntityInput;
}>;


export type ProductOfferingUwStartingConfigs_DeleteMutation = { __typename?: 'Mutation', deleteProductOfferingStartingConfig: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type ProductOfferingUwStartingConfigs_SaveMutationVariables = Types.Exact<{
  input: Types.SaveProductOfferingStartingConfigInput;
}>;


export type ProductOfferingUwStartingConfigs_SaveMutation = { __typename?: 'Mutation', saveProductOfferingStartingConfig: { __typename?: 'SaveProductOfferingStartingConfigResult', productOfferingStartingConfig: { __typename?: 'ProductOfferingStartingConfig', id: string, pinnedOptions: Array<{ __typename?: 'ReadyPlanOption', active: boolean, order: number, id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, active: boolean, forDesignPackages: boolean } }> } } };

export type ProductOfferingUwStartingConfig_DetailFragment = { __typename?: 'ProductOfferingStartingConfig', id: string, pinnedOptions: Array<{ __typename?: 'ReadyPlanOption', active: boolean, order: number, id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, active: boolean, forDesignPackages: boolean } }> };

export type ProductOfferingUwStartingConfig_OptionFragment = { __typename?: 'ReadyPlanOption', active: boolean, order: number, id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, active: boolean, forDesignPackages: boolean } };

export const ProductOfferingUwStartingConfig_OptionFragmentDoc = gql`
    fragment ProductOfferingUwStartingConfig_Option on ReadyPlanOption {
  ...DisplayNamed
  active
  order
  optionGroup {
    id
    name
    order
    active
    forDesignPackages
  }
}
    ${DisplayNamedFragmentDoc}`;
export const ProductOfferingUwStartingConfig_DetailFragmentDoc = gql`
    fragment ProductOfferingUwStartingConfig_Detail on ProductOfferingStartingConfig {
  id
  pinnedOptions {
    ...ProductOfferingUwStartingConfig_Option
  }
}
    ${ProductOfferingUwStartingConfig_OptionFragmentDoc}`;
export const ProductOfferingUwStartingConfigsPageDocument = gql`
    query ProductOfferingUwStartingConfigsPage($productOfferingId: ID!) {
  productOffering(id: $productOfferingId) {
    ...Named
    project {
      id
    }
    aggregateCheckout {
      id
    }
  }
  productOfferingStartingConfigs(
    filter: {productOfferingId: [$productOfferingId], type: [UNDERWRITING]}
  ) {
    entities {
      ...ProductOfferingUwStartingConfig_Detail
    }
  }
}
    ${NamedFragmentDoc}
${ProductOfferingUwStartingConfig_DetailFragmentDoc}`;

/**
 * __useProductOfferingUwStartingConfigsPageQuery__
 *
 * To run a query within a React component, call `useProductOfferingUwStartingConfigsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingUwStartingConfigsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingUwStartingConfigsPageQuery({
 *   variables: {
 *      productOfferingId: // value for 'productOfferingId'
 *   },
 * });
 */
export function useProductOfferingUwStartingConfigsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingUwStartingConfigsPageQuery, ProductOfferingUwStartingConfigsPageQueryVariables> & ({ variables: ProductOfferingUwStartingConfigsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingUwStartingConfigsPageQuery, ProductOfferingUwStartingConfigsPageQueryVariables>(ProductOfferingUwStartingConfigsPageDocument, options);
      }
export function useProductOfferingUwStartingConfigsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingUwStartingConfigsPageQuery, ProductOfferingUwStartingConfigsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingUwStartingConfigsPageQuery, ProductOfferingUwStartingConfigsPageQueryVariables>(ProductOfferingUwStartingConfigsPageDocument, options);
        }
// @ts-ignore
export function useProductOfferingUwStartingConfigsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingUwStartingConfigsPageQuery, ProductOfferingUwStartingConfigsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingUwStartingConfigsPageQuery, ProductOfferingUwStartingConfigsPageQueryVariables>;
export function useProductOfferingUwStartingConfigsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingUwStartingConfigsPageQuery, ProductOfferingUwStartingConfigsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingUwStartingConfigsPageQuery | undefined, ProductOfferingUwStartingConfigsPageQueryVariables>;
export function useProductOfferingUwStartingConfigsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingUwStartingConfigsPageQuery, ProductOfferingUwStartingConfigsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingUwStartingConfigsPageQuery, ProductOfferingUwStartingConfigsPageQueryVariables>(ProductOfferingUwStartingConfigsPageDocument, options);
        }
export type ProductOfferingUwStartingConfigsPageQueryHookResult = ReturnType<typeof useProductOfferingUwStartingConfigsPageQuery>;
export type ProductOfferingUwStartingConfigsPageLazyQueryHookResult = ReturnType<typeof useProductOfferingUwStartingConfigsPageLazyQuery>;
export type ProductOfferingUwStartingConfigsPageSuspenseQueryHookResult = ReturnType<typeof useProductOfferingUwStartingConfigsPageSuspenseQuery>;
export type ProductOfferingUwStartingConfigsPageQueryResult = ApolloReactCommon.QueryResult<ProductOfferingUwStartingConfigsPageQuery, ProductOfferingUwStartingConfigsPageQueryVariables>;
export const ProductOfferingUwStartingConfigs_CheckoutOptionsDocument = gql`
    query ProductOfferingUwStartingConfigs_CheckoutOptions($productOfferingId: ID!, $versionId: ID) {
  productOffering(id: $productOfferingId, versionId: $versionId) {
    id
    options {
      ...ProductOfferingUwStartingConfig_Option
    }
  }
}
    ${ProductOfferingUwStartingConfig_OptionFragmentDoc}`;

/**
 * __useProductOfferingUwStartingConfigs_CheckoutOptionsQuery__
 *
 * To run a query within a React component, call `useProductOfferingUwStartingConfigs_CheckoutOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingUwStartingConfigs_CheckoutOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingUwStartingConfigs_CheckoutOptionsQuery({
 *   variables: {
 *      productOfferingId: // value for 'productOfferingId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useProductOfferingUwStartingConfigs_CheckoutOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingUwStartingConfigs_CheckoutOptionsQuery, ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables> & ({ variables: ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingUwStartingConfigs_CheckoutOptionsQuery, ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables>(ProductOfferingUwStartingConfigs_CheckoutOptionsDocument, options);
      }
export function useProductOfferingUwStartingConfigs_CheckoutOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingUwStartingConfigs_CheckoutOptionsQuery, ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingUwStartingConfigs_CheckoutOptionsQuery, ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables>(ProductOfferingUwStartingConfigs_CheckoutOptionsDocument, options);
        }
// @ts-ignore
export function useProductOfferingUwStartingConfigs_CheckoutOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingUwStartingConfigs_CheckoutOptionsQuery, ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingUwStartingConfigs_CheckoutOptionsQuery, ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables>;
export function useProductOfferingUwStartingConfigs_CheckoutOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingUwStartingConfigs_CheckoutOptionsQuery, ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingUwStartingConfigs_CheckoutOptionsQuery | undefined, ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables>;
export function useProductOfferingUwStartingConfigs_CheckoutOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingUwStartingConfigs_CheckoutOptionsQuery, ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingUwStartingConfigs_CheckoutOptionsQuery, ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables>(ProductOfferingUwStartingConfigs_CheckoutOptionsDocument, options);
        }
export type ProductOfferingUwStartingConfigs_CheckoutOptionsQueryHookResult = ReturnType<typeof useProductOfferingUwStartingConfigs_CheckoutOptionsQuery>;
export type ProductOfferingUwStartingConfigs_CheckoutOptionsLazyQueryHookResult = ReturnType<typeof useProductOfferingUwStartingConfigs_CheckoutOptionsLazyQuery>;
export type ProductOfferingUwStartingConfigs_CheckoutOptionsSuspenseQueryHookResult = ReturnType<typeof useProductOfferingUwStartingConfigs_CheckoutOptionsSuspenseQuery>;
export type ProductOfferingUwStartingConfigs_CheckoutOptionsQueryResult = ApolloReactCommon.QueryResult<ProductOfferingUwStartingConfigs_CheckoutOptionsQuery, ProductOfferingUwStartingConfigs_CheckoutOptionsQueryVariables>;
export const ProductOfferingUwStartingConfigs_DeleteDocument = gql`
    mutation ProductOfferingUwStartingConfigs_Delete($input: DeleteEntityInput!) {
  deleteProductOfferingStartingConfig(input: $input) {
    emptyResult
  }
}
    `;

/**
 * __useProductOfferingUwStartingConfigs_DeleteMutation__
 *
 * To run a mutation, you first call `useProductOfferingUwStartingConfigs_DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingUwStartingConfigs_DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productOfferingUwStartingConfigsDeleteMutation, { data, loading, error }] = useProductOfferingUwStartingConfigs_DeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductOfferingUwStartingConfigs_DeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProductOfferingUwStartingConfigs_DeleteMutation, ProductOfferingUwStartingConfigs_DeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProductOfferingUwStartingConfigs_DeleteMutation, ProductOfferingUwStartingConfigs_DeleteMutationVariables>(ProductOfferingUwStartingConfigs_DeleteDocument, options);
      }
export type ProductOfferingUwStartingConfigs_DeleteMutationHookResult = ReturnType<typeof useProductOfferingUwStartingConfigs_DeleteMutation>;
export type ProductOfferingUwStartingConfigs_DeleteMutationResult = ApolloReactCommon.MutationResult<ProductOfferingUwStartingConfigs_DeleteMutation>;
export const ProductOfferingUwStartingConfigs_SaveDocument = gql`
    mutation ProductOfferingUwStartingConfigs_Save($input: SaveProductOfferingStartingConfigInput!) {
  saveProductOfferingStartingConfig(input: $input) {
    productOfferingStartingConfig {
      ...ProductOfferingUwStartingConfig_Detail
    }
  }
}
    ${ProductOfferingUwStartingConfig_DetailFragmentDoc}`;

/**
 * __useProductOfferingUwStartingConfigs_SaveMutation__
 *
 * To run a mutation, you first call `useProductOfferingUwStartingConfigs_SaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingUwStartingConfigs_SaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productOfferingUwStartingConfigsSaveMutation, { data, loading, error }] = useProductOfferingUwStartingConfigs_SaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductOfferingUwStartingConfigs_SaveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProductOfferingUwStartingConfigs_SaveMutation, ProductOfferingUwStartingConfigs_SaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProductOfferingUwStartingConfigs_SaveMutation, ProductOfferingUwStartingConfigs_SaveMutationVariables>(ProductOfferingUwStartingConfigs_SaveDocument, options);
      }
export type ProductOfferingUwStartingConfigs_SaveMutationHookResult = ReturnType<typeof useProductOfferingUwStartingConfigs_SaveMutation>;
export type ProductOfferingUwStartingConfigs_SaveMutationResult = ApolloReactCommon.MutationResult<ProductOfferingUwStartingConfigs_SaveMutation>;